import css from 'styled-jsx/css';

export default css`.notify .title {
  padding: 0.5em;
  font-size: 1em; }
`